import bemBlock from '@gik/core/utils/bemBlock';
import { useHideIntercomDefaultLauncher } from '@gik/core/utils/Intercom';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { Button } from '@gik/ui/Button';
import { DragDoubleArrow } from '@gik/ui/SvgIcon/GikIcons/DragDoubleArrow';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import UploadIcon from '@heroicons/react/solid/UploadIcon';
import CloseIcon from '@heroicons/react/solid/XIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CoverPhotoEditorDirection } from './CoverPhotoEditor';

interface IInkindCoverUploadImageControlsProps {
  isSaving: boolean;
  onCancel(): void;
  onSave(): void;
  direction?: CoverPhotoEditorDirection;
}
export default function InkindCoverUploadImageControlsComp({
  onCancel,
  onSave,
  isSaving,
  direction,
}: IInkindCoverUploadImageControlsProps) {
  const bem = bemBlock('inkind-cover-upload-controls');
  const { t } = useTranslation();
  useHideIntercomDefaultLauncher();

  return (
    <>
      {!isSaving && (
        <Button type="button" variant="secondary" circle className={bem('cancel')} onClick={onCancel}>
          <SvgIcon Icon={CloseIcon} size="base" />
        </Button>
      )}
      <Button
        type="button"
        variant="secondary"
        className={bem('save')}
        loading={isSaving}
        onClick={onSave}
        prepend={<SvgIcon Icon={UploadIcon} size="base" />}
      >
        {t(translationKeys.PageHeaderSavePhoto)}
      </Button>
      {(direction === 'vertical' || direction === 'horizontal') && (
        <div className={bem('drag-hint', [{ horizontal: direction === 'horizontal' }])}>
          <SvgIcon Icon={DragDoubleArrow} size="base" />
          <span>Drag to position</span>
        </div>
      )}
    </>
  );
}

export const InkindCoverUploadImageControls = withComponentErrorBoundary(InkindCoverUploadImageControlsComp);
